import { Component, computed, Input, OnInit, Signal, signal, WritableSignal } from '@angular/core'
import { IFooterModalData } from '@components/exportable/footer/interfaces/i-footer-modal-data'
import { find } from 'lodash-es'
import { ModalOkComponent } from '@components/group-modals/components/modal-ok/modal-ok.component'
import { CommonModule } from '@angular/common'
import { I18nResponse } from '@interfaces/i-i18n'
import { TranslationCacheService } from '@services/translation-cache/translation-cache.service'
import { logger } from '@utils/logger'
import { modalData } from '@components/exportable/footer/data/footer'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [ CommonModule, ModalOkComponent],
})
export class FooterComponent implements OnInit {
  // signal inputs need ng17
  @Input({ required: true }) appInformation: string

  showModal: WritableSignal<boolean> = signal(false)
  modalDatas: WritableSignal<IFooterModalData[]> = signal(null)
  modalTitle: WritableSignal<string> = signal(null)
  modalData: Signal<IFooterModalData> = computed(() => {
    return find(this.modalDatas(), { title: {value:  this.modalTitle() }})
  })

  constructor(public translationCacheService: TranslationCacheService) {
  }

  ngOnInit() {
    this.translationCacheService.translationCache$.subscribe({
      next: (response: I18nResponse) => {
        this.modalDatas().forEach(item => {
          if (Object.keys(response).includes(item.title.code)){
               item.title.value = response[item.title.code].value
          }
          if (Object.keys(response).includes(item.body.code)){
            item.body.value = response[item.body.code].value
          }
        })
      },
      error: (err) => {
        logger('error', err.message)
      },
    })

    this.modalDatas.set(modalData)

    this.translationCacheService.requestTranslations([
        ...this.modalDatas().map((item) => ({default: item.title.value, code: item.title.code})),
        ...this.modalDatas().map((item) => ({default: item.body.value, code: item.body.code})),
      ],
    )
  }

  onModalClose() {
    this.showModal.set(false)
  }

  onModalOpen(title: string) {
    this.modalTitle.set(title)
    this.showModal.set(true)
  }

  trackByFunc(_idx: number, modalData: IFooterModalData): string {
    return modalData.title.value
  }
}
